import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Check if user must change password (handles boolean or truthy from API)
  if (user.mustChangePassword) {
    return <Navigate to="/change-password" replace />;
  }

  const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
  
  if (!roles.includes(user.role)) {
    // Redirect based on user role
    const roleRoutes = {
      power_user: '/power-user',
      admin: '/admin',
      manager: '/manager',
      site: '/site'
    };
    return <Navigate to={roleRoutes[user.role] || '/login'} replace />;
  }

  return children;
};

export default PrivateRoute;
